import { render, staticRenderFns } from "./DetallePTU.vue?vue&type=template&id=bc80a5d8&scoped=true"
import script from "./DetallePTU.vue?vue&type=script&lang=js"
export * from "./DetallePTU.vue?vue&type=script&lang=js"
import style0 from "./DetallePTU.vue?vue&type=style&index=0&id=bc80a5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80a5d8",
  null
  
)

export default component.exports